import { Typography } from '@mui/material';
import StepComponent from '../components/step.component';
import { UiSchemaGenerator } from '../../shared/ui-schema-generator';
import validator from '@rjsf/validator-ajv8';
import { isTariffCountryNameValid } from '../../shared/device-details-utils';
import { STEP_IDS } from './index';

export default {
  title: 'Energy Tariff',
  description: 'Choosing the appropriate energy tariff will allow FlexiO to optimize savings and earnings.',
  helperText: {
    header: (
      <>
        <Typography variant="h6">Select the correct Tariff structure.</Typography>
        <Typography
          variant="body"
          fontWeight={500}
        >
          ℹ️ Necessary for running FlexiO fluently and getting the most out of possible savings and earnings.
        </Typography>
      </>
    ),
  },
  component: StepComponent,
  schemaFunction: ({ schemas }, _changes) => {
    if ('tariffStructure' in schemas.properties) {
      return {
        ...schemas,
        properties: {
          tariffStructure: schemas.properties.tariffStructure,
        },
        required: ['tariffStructure'],
      };
    } else {
      return {
        properties: {
          countryStructure: schemas.properties.countryStructure,
        },
      };
    }
  },
  validateFunction: (schema, formData, allWizardFormData, changes) => {
    if (!formData) {
      return true;
    }

    const isValid = true;

    if (formData.countryStructure) {
      if (!validator.isValid(schema, { countryStructure: formData.countryStructure }, schema)) {
        return false;
      }

      const addressChanges = changes.get(STEP_IDS.ADDRESS);
      const configuredCountryName = addressChanges?.country || allWizardFormData.ADDRESS.country;

      if (!isTariffCountryNameValid(configuredCountryName, formData.countryStructure.countryName)) {
        return false;
      }
    }

    return isValid;
  },
  diffFunction: (_diffObj) => {
    return {};
    /*return {
      tariffStructure: get(diffObj, "settings.tariffStructure", false),
    }*/
  },
  updateUiSchema: (schema, uiSchema) => {
    if (schema.properties.countryStructure !== undefined) {
      return {
        'ui:options': {
          title: '',
          description: '',
        },
        countryStructure: new UiSchemaGenerator.TariffStructureBuilder().build(),
      };
    } else {
      return uiSchema;
    }
  },
  customValidator: (formData, errors, _uiSchema, configurationData, changes) => {
    const addressChanges = changes.get(STEP_IDS.ADDRESS);
    const configuredCountryName = addressChanges?.country || configurationData.ADDRESS.country;

    if (!isTariffCountryNameValid(configuredCountryName, formData.countryStructure?.countryName)) {
      errors.countryStructure.addError('The tariff country must match the configured country name or be set to CUSTOM');
    }

    return errors;
  },
  uiSchema: {
    'ui:options': {
      title: false,
      description: false,
    },
    tariffType: {
      'ui:widget': 'hidden',
    },
    tariffStructure: {
      'ui:options': {
        title: false,
        description: false,
      },
      tariffType: {
        'ui:widget': 'hidden',
      },
    },
  },
};
